import React, { useState } from 'react'
import { cn } from 'utils'

import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'

const textObject: {
  [key: string]: Array<{
    topic: string
    subTopics: Array<string>
  }>
} = {
  dsa: [
    {
      topic: ' Intro to Python Fundamentals',
      subTopics: ['Lists/Sets/Dictionary', 'Loops', 'Functions']
    },
    {
      topic: 'Programming Fundamentals',
      subTopics: [
        'Data type and structures',
        'Flow control structures (Conditionals and loops)',
        'Functional programming',
        'Object-oriented programming'
      ]
    },
    {
      topic: 'Data Structures and Algorithms',
      subTopics: ['Arrays', 'Strings', 'Recursion', ' Searching & Sorting']
    },
    {
      topic: 'Advance Data Structures and algorithms',
      subTopics: ['Graphs', 'Trees', 'Heaps', 'Backtracking']
    }
  ],
  frontend: [
    {
      topic: 'HTML/CSS',
      subTopics: ['Flexbox', 'Bootstrap', 'SEO', 'Animations']
    },
    {
      topic: 'Javascript',
      subTopics: ['Js Basics', 'ES6', 'Closures', 'Typescript']
    },
    {
      topic: 'React',
      subTopics: ['JSX', 'Props', 'Hooks', 'GraphQl']
    },
    {
      topic: 'Projects',
      subTopics: ['Netflix clone app', 'Spotify clone app', 'Ecommerce website']
    }
  ],
  backend: [
    {
      topic: 'Git / Github',
      subTopics: ['Repository', 'Pull / Push', 'Conflicts']
    },
    {
      topic: 'Introduction to Backend',
      subTopics: ['Servers', 'Databases', 'APIs', 'Authentication']
    },
    {
      topic: 'NodeJS',
      subTopics: ['Rest API', 'CRUD', 'Express JS', 'Async Programming']
    },
    {
      topic: 'Projects',
      subTopics: ['Meet App', 'Calendly App', 'File share', 'Daily Planner']
    }
  ]
}

const topicKey = [
  { key: 'dsa', label: 'DSA' },
  { key: 'frontend', label: 'Frontend' },
  { key: 'backend', label: 'Backend' }
]

const ProgramCurriculum = () => {
  const [currentTab, setCurrentTab] = useState('dsa')
  return (
    <SectionLayout className="bg-[#3C3C78]">
      <SectionHeader>
        <span className="text-primary">Program</span> Curriculum
      </SectionHeader>
      <SectionContent className="flex sm:flex-row flex-col flex-nowrap">
        <section className="flex flex-row sm:flex-col gap-2 sm:gap-10 z-100 sm:w-40">
          {topicKey.map((obj) => (
            <div
              key={obj.key}
              onClick={() => setCurrentTab(obj.key)}
              className={cn(
                'w-full px-2 py-3 sm:py-10 cursor-pointer bg-[#18181B2E] text-center rounded',
                currentTab === obj.key
                  ? 'text-white font-semibold border-1 border-white'
                  : 'text-[#C8C8FF]'
              )}>
              {obj.label}
            </div>
          ))}
        </section>
        <section className="flex flex-col gap-6 sm:w-7/12">
          {textObject[currentTab].map((data, idx) => {
            return (
              <div
                key={idx}
                className="px-5 sm:px-8 py-3 flex flex-col gap-4 bg-gray-100 rounded">
                <div className="text-black text-2xl font-semibold">
                  {data.topic}
                </div>
                <div className="flex flex-wrap gap-2">
                  {data.subTopics.map((subtopic, i) => (
                    <div
                      key={i}
                      className="rounded-full text-sm bg-primary-very-light text-primary-very-dark py-2 px-5">
                      {subtopic}
                    </div>
                  ))}
                </div>
              </div>
            )
          })}
        </section>
      </SectionContent>
    </SectionLayout>
  )
}

export default ProgramCurriculum
